import i18n from '@shared/i18n/index';

/**
 * 项目功能开关
 */

// 采用异步生成
export const ENABLE_DIGITAL_ASYNC = false;

// 节点式应用使用 nodeParam or 原 param 参数生图
export const ENABLE_NODE_PARAM = true;

//dag开关
export const ENABLE_NEW_DAG = true;

export const getEnableNodeParamGenerate = () => {
	if ((window as any).disableNodeParam) {
		return false;
	}

	return ENABLE_NODE_PARAM;
};

export const getEnableNewDag = () => {
	if ((window as any).newDag) {
		return true;
	}
	return ENABLE_NEW_DAG;
};

// 支付开关
export const ENABLE_PAYMENT = true;

export const GENERATE_TIMEOUT = 10 * 60 * 1000;
export const OPTIMIZE_TIMEOUT = 300000;

// 表单式应用允许版本
export const APP_FORM_CONFIG = {
	ALLOW_VERSIONS: [1, 2],
	LATEST_VERSION: 2,
};

// 节点式应用允许版本
export const APP_NODE_CONFIG = {
	ALLOW_VERSIONS: [1, 2],
	LATEST_VERSION: 2,
};

export enum TaskAction {
	WATERMARK = 'watermark',
	DOWNLOAD = 'download',
	ENHANCE = 'enhance',
	POST = 'post',
	SHARE = 'share',
	MORE = 'more',
}

export const TaskButton = {
	enhance: {
		iconType: TaskAction.ENHANCE,
		get text() {
			return i18n.get('Business_HD_Action');
		},
	},
	watermark: {
		iconType: TaskAction.WATERMARK,
		get text() {
			return i18n.get('ResultPage_Watermark_Button');
		},
	},
	download: {
		iconType: TaskAction.DOWNLOAD,
		get text() {
			return i18n.get('Business_Download_Action');
		},
	},
	post: {
		iconType: TaskAction.POST,
		get text() {
			return i18n.get('ResultPage_Post_Button');
		},
	},
	share: {
		iconType: TaskAction.SHARE,
		get text() {
			return i18n.get('Business_Share_Action');
		},
	},
	more: {
		iconType: TaskAction.MORE,
		get text() {
			return i18n.get('Business_More_Action');
		},
	},
};
